<template>
    <div v-if="isModalOpen">
    <div style="opacity: 70%;" class="fixed top-0 left-0 right-0 bottom-0 bg-black z-50"></div>
        <div class="fixed top-0 left-0 right-0 bottom-0 flex overflow-x-hidden overflow-y-auto h-full z-50 justify-center items-center">
            <div class="relative w-full max-w-[350px] h-full md:h-auto content-center bg-white border border-b-black">
            <div class="modal-header flex items-center justify-between">
                <h1 class="text-lg font-bold">Manage Trial</h1>
                <button type="button" class="close" data-dismiss="modal" aria-label="Close" @click="closeManageDurationModal">
                    <span aria-hidden="true">&times;</span>
                </button>
            </div>
            <div class="modal-body">
                <div class="relative w-full">
                    <div v-if="hasOnlyEmail(existingGroupAccessArray) || hasOnlyEmail(selectedGroupAccessArray)">
                        <!-- Existing Group Access -->
                        <div v-if="hasOnlyEmail(existingGroupAccessArray)">
                            <div v-for="(groupAccess, index) in existingGroupAccessArray" :key="index" class="row mb-3">
                                <div class="col-md-10">
                                    <div class="row">
                                        <div class="col-md-12">
                                            <span class="font-bold">{{ groupAccess.name }}</span>
                                        </div>
                                        <div class="col-md-12 flex align-items-center">
                                            <span style="font-size: 12px !important;" class="text-danger">Expires on: </span>
                                            <span
                                                v-if="!groupAccess.isEditing"
                                                @click="startEditing(index)"
                                                class="ml-2 flex align-items-center cursor-pointer"
                                                style="font-size: 12px !important;"
                                            >
                                            <span class="text-danger">{{ groupAccess.formattedDate }}</span>
                                               <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 16 16" fill="currentColor" class="w-4 h-4 ml-2 text-blue-600"  v-tooltip="{ content: 'Extend trial', placement: 'top', triggers: 'hover' }">
                                                  <path d="M5.75 7.5a.75.75 0 1 0 0 1.5.75.75 0 0 0 0-1.5ZM5 10.25a.75.75 0 1 1 1.5 0 .75.75 0 0 1-1.5 0ZM10.25 7.5a.75.75 0 1 0 0 1.5.75.75 0 0 0 0-1.5ZM7.25 8.25a.75.75 0 1 1 1.5 0 .75.75 0 0 1-1.5 0ZM8 9.5A.75.75 0 1 0 8 11a.75.75 0 0 0 0-1.5Z" />
                                                  <path fill-rule="evenodd" d="M4.75 1a.75.75 0 0 0-.75.75V3a2 2 0 0 0-2 2v7a2 2 0 0 0 2 2h8a2 2 0 0 0 2-2V5a2 2 0 0 0-2-2V1.75a.75.75 0 0 0-1.5 0V3h-5V1.75A.75.75 0 0 0 4.75 1ZM3.5 7a1 1 0 0 1 1-1h7a1 1 0 0 1 1 1v4.5a1 1 0 0 1-1 1h-7a1 1 0 0 1-1-1V7Z" clip-rule="evenodd" />
                                                </svg>
                                            </span>
                                            <span v-if="groupAccess.isEditing">
                                                <input v-model="groupAccess.editedDate" id="expirationDate" :min="minAllowedDate()" type="date" class="text-gray-700 leading-tight border rounded px-2 py-1 ml-2" />
                                            </span>
                                        </div>

                                    </div>
                                </div>
                                <div class="col-md-2 d-flex align-items-center justify-content-end">
                                    <button v-show="!groupAccess.isEditing"
                                            ref="cancelButton"
                                            @click="cancelSubscription"
                                            class="cursor-pointer"
                                            v-tooltip="{ content: 'Remove trial', placement: 'top', triggers: 'hover' }
                                           "
                                    >
                                        ❌
                                    </button>
                                    <button v-show="groupAccess.isEditing" @click="update(index)" class="cursor-pointer custom-button-update">Update</button>
                                </div>
                            </div>
                        </div>
                        <!-- Selected Group Access -->
                        <div v-if="selectedGroupAccessArray.length > 0">
                            <div v-for="(selectedAccess, index) in selectedGroupAccessArray" :key="index" class="row mb-3">
                                <div class="col-md-10">
                                    <div class="row mb-2">
                                        <div class="col-md-12">
                                            <span class="font-bold">{{ selectedAccess.name }}</span>
                                        </div>
                                        <div class="col-md-12">
                                            <span style="font-size: 12px !important;" class="text-danger">Expires on:</span>
                                            <span style="font-size: 12px !important;" class="text-danger fs-6">{{ selectedAccess.editedDate }}</span>
                                        </div>
                                    </div>
                                </div>
                                <div class="col-md-2 d-flex align-items-center justify-content-end">
                                    <button @click="cancelGroupAccess(selectedAccess.id)" class="ml-2 cursor-pointer flex-grow">❌</button>
                                </div>
                            </div>
                        </div>
                    </div>
                    <div v-else>
                        No existing trial group access
                    </div>
                    <!-- Add New Trial -->
                    <div v-if="showAddGroupAccess" id="select-group-access-option" class="mt-2">
                        <div class="w-full">
                            <label for="select-group-access" class="block">Select Group Access</label>
                            <div class="relative flex flex-wrap items-center">
                                <select v-model="selectedGroupAccess.name" name="select-group-access" id="select-group-access" class="border rounded py-1 px-2 text-gray-700 leading-tight focus:outline-none focus:shadow-outline w-full">
                                    <option v-for="group in trialGroupAccessList" :key="group.id" :value="group" :disabled="isGroupDisabled(group)">
                                        {{ group.name }}
                                    </option>
                                </select>
                            </div>
                        </div>
                        <div class="w-full mt-2">
                            <div>
                                <span class="font-bold">Expiration Date: </span>
                                <span class="text-danger">*</span>
                            </div>
                        </div>
                        <div class="w-full flex items-center">
                                <input v-model="selectedGroupAccess.date" type="date" class="text-gray-700 leading-tight py-2 px-2 border rounded w-full" :min="minAllowedDate()"/>
                        </div>
                        <div class="w-full flex items-center mt-2">
                            <button type="button" @click="addGroupAccess" class="text-blue-700 border py-1 px-3 rounded" :disabled="!selectedGroupAccess.date">Add</button>
                        </div>
                    </div>
                    <button v-if="!showAddGroupAccess"
                            type="button"
                            id="add-another-group-access"
                            @click="openAddGroupAccess"
                            class="btn btn-outline-secondary mt-4"
                            style="padding: 5px 15px; border-radius: 5px; background: #eee; color: #000; outline: 0; border: none !important;"
                    >
                        + Add Trial
                    </button>
                 </div>
            </div>
            <div class="modal-footer flex justify-end">
                <button @click="saveChanges" class="btn btn-primary" :disabled="isLoading">
                    <span v-if="isLoading">Saving...</span>
                    <span v-else>Save Changes</span>
                </button>
                <button @click="closeManageDurationModal" class="btn btn-secondary">Close</button>
            </div>
            </div>
        </div>
    </div>
</template>
<script>
import axios from "axios";
import Vue from "vue";
export default {
    props: {
        userEmail: {
            type: String,
            default: '',
        },
    },
    data() {
        return {
            deletedTrialGroupAccess: [],
            existingGroupAccessArray: [],
            updatedExistingGroupAccess:[],
            payloads: [],
            isModalOpen: false,
            modalId: '',
            manageDurationData: [],
            selectedGroupAccessArray: [],
            showAddGroupAccess: false,
            trialGroupAccessList: [
                { id: 'subqgvtop50', name: 'FA Alpha'},
                { id: 'subfaalphapulse', name: 'Fa Alpha Pulse' },
                { id: 'subappaccess', name: 'Everything' },
                { id: 'suballusaccess', name: 'Everything US (All Newsletters & US Database)' },
                { id: 'subappentiredb', name: 'Entire Database' },
                { id: 'subappafricadb', name: 'Africa & Latin America Database' },
                { id: 'subappasiadb', name: 'Asia Database' },
                { id: 'subappusdb', name: 'US Database' },
                { id: 'subappcredit', name: 'Credit Newsletters (VCWI, UAFRS)' },
                { id: 'subappequity', name: 'Equity Newsletters (VEII, VEIH, CLL, UAFRS, TSIL)' },
                { id: 'submacronewsletters', name: 'Market Phase Cycle' },
                { id: 'suballnewsletters', name: 'All Valens Research Newsletters' },
                { id: 'subappeuropedb', name: 'Europe Database' },
                { id: 'Trial', name: 'Trial' },
            ],
            selectedGroupAccess: { name: '', date: '' },
            csrf: document.querySelector('meta[name="csrf-token"]').getAttribute('content'),
            isEditing: false,
            loading: true,
            isLoading: false,
        };
    },
    mounted() {
    },
    methods: {
        minAllowedDate() {
            const today = new Date();

            // Format the date as 'YYYY-MM-DD' for input's min attribute
            const year = today.getFullYear();
            const month = (today.getMonth() + 1).toString().padStart(2, '0');
            const day = today.getDate().toString().padStart(2, '0');

            return `${year}-${month}-${day}`;
        },

        isGroupDisabled(group) {
            return this.existingGroupAccessArray.some(existingGroup => existingGroup.name === group.name) ||
                this.selectedGroupAccessArray.some(selectedGroup => selectedGroup.name === group.name);
        },
        hasOnlyEmail(array) {
            const firstItem = array && array[0];
            return firstItem && Object.keys(firstItem).length >= 2;
        },

        openModal(id) {
            this.modalId = id;
            this.fetchUserData(id).then(data => {
                Vue.set(this, 'existingGroupAccessArray', data);
                this.isModalOpen = true;
            });
        },

        async fetchUserData(id) {
            const response = await axios.get(`/api/user-trial-account/${id}`);
            const groupAccessDataArray = response.data;

            if (groupAccessDataArray && groupAccessDataArray.length > 0) {
                return groupAccessDataArray.map(groupAccessData => {
                    const matchingTrialGroup = this.trialGroupAccessList.find(trialGroup => trialGroup.id === groupAccessData.group_access);
                    const dateParts = groupAccessData.expiration_date.split(' ');
                    const formattedDate = dateParts[0];

                    return {
                        email: groupAccessData.email,
                        name: matchingTrialGroup ? matchingTrialGroup.name : null,
                        formattedDate: formattedDate,
                        isEditing: false,
                    };
                });
            } else {
                return [{
                    email: id,
                }];
            }
        },

        startEditing(index) {
            const userConfirmation = confirm('Do you want to update the date of expiration?');

            if (userConfirmation) {
                this.existingGroupAccessArray[index].editedDate = this.existingGroupAccessArray[index].formattedDate;
                this.existingGroupAccessArray[index].isEditing = true;
            } else {
                this.existingGroupAccessArray[index].isEditing = false;
            }
        },


        cancelSubscription(index) {
            const userConfirmation = confirm('Do you want to cancel this subscription?');

            if (userConfirmation) {
                const deletedData = this.existingGroupAccessArray.splice(index, 1)[0];
                deletedData.isEditing = false;

                if (!Array.isArray(this.deletedTrialGroupAccess)) {
                    this.$set(this, 'deletedTrialGroupAccess', []);
                }

                this.deletedTrialGroupAccess.push(deletedData);

                this.editingIndex = null;
                this.editedDate = null;
            } else {

            }
        },


        cancelGroupAccess(groupId) {
            const indexToRemove = this.selectedGroupAccessArray.findIndex(access => access.id === groupId);
            if (indexToRemove !== -1) {
                this.selectedGroupAccessArray.splice(indexToRemove, 1);
            }
        },
        addGroupAccess() {
            if (!this.selectedGroupAccess.name || !this.selectedGroupAccess.date) {
                return;
            }

            const newGroupAccess = {
                name: this.selectedGroupAccess.name.name,
                editedDate: this.selectedGroupAccess.date,
                email: this.existingGroupAccessArray.length > 0 ? this.existingGroupAccessArray[0].email : null,
            };


            this.selectedGroupAccessArray.push(newGroupAccess);
            this.selectedGroupAccess = { name: '', date: null };
            this.showAddGroupAccess = false;
        },

        openAddGroupAccess() {
            this.showAddGroupAccess = true;
        },
        closeManageDurationModal() {
            this.isModalOpen = false;
            this.selectedGroupAccess = { name: '', date: null };
            this.showAddGroupAccess = false;
            this.selectedGroupAccessArray = [];
        },
        update(index) {
            const updatedData = {
                ...this.existingGroupAccessArray[index],
                isEditing: false,
                formattedDate: this.existingGroupAccessArray[index].editedDate,
            };

            if (!this.updatedExistingGroupAccess) {
                this.$set(this, 'updatedExistingGroupAccess', []);
            }

            this.updatedExistingGroupAccess.push(updatedData);
            this.$set(this.existingGroupAccessArray, index, updatedData);
        },


        async saveChanges() {
            const payloads = [];

            if (this.updatedExistingGroupAccess && this.updatedExistingGroupAccess.length > 0) {
                for (let i = 0; i < this.updatedExistingGroupAccess.length; i++) {
                    const updatedData = this.updatedExistingGroupAccess[i];
                    const matchingTrialGroup = this.trialGroupAccessList.find(trialGroup => trialGroup.name === updatedData.name);

                    const updatePayload = {
                        operation: 'update',
                        expiration_date: updatedData.editedDate,
                        email: updatedData.email,
                        group_access: matchingTrialGroup.id,
                    };

                    payloads.push(updatePayload);
                }
            }

            if (this.deletedTrialGroupAccess && this.deletedTrialGroupAccess.length > 0) {
                for (let i = 0; i < this.deletedTrialGroupAccess.length; i++) {
                    const deactivateAccount = this.deletedTrialGroupAccess[i];
                    const matchingGroup = this.trialGroupAccessList.find(trialGroup => trialGroup.name === deactivateAccount.name);

                    const cancelPayload = {
                        operation: 'cancel',
                        email: deactivateAccount.email,
                        group_access: matchingGroup.id,
                    };

                    payloads.push(cancelPayload);
                }
            }

            if (this.selectedGroupAccessArray && this.selectedGroupAccessArray.length > 0) {
                for (let i = 0; i < this.selectedGroupAccessArray.length; i++) {
                    const selectedAccess = this.selectedGroupAccessArray[i];
                    const matchingTrialGroup = this.trialGroupAccessList.find(trialGroup => trialGroup.name === selectedAccess.name);

                    const addPayload = {
                        operation: 'add',
                        expiration_date: selectedAccess.editedDate,
                        email: selectedAccess.email,
                        group_access: matchingTrialGroup.id,
                    };

                    payloads.push(addPayload);
                }
            }
            try {
                this.isLoading = true;

                const response = await axios.post(`/api/trial-group-access-function`, {
                    payloads: payloads,
                    __token: this.csrf,
                });

                console.log('Update successful:', response.data);

                this.$set(this, 'updatedExistingGroupAccess', null);
                this.$set(this, 'deletedTrialGroupAccess', null);
            } catch (error) {
                console.error('Error updating user data:', error);
                throw error;
            } finally {
                setTimeout(() => {
                    this.isLoading = false;
                    window.location.reload();
                    this.closeManageDurationModal();
                }, 3000);
            }
        },
    },
};
</script>
<style scoped lang="scss">

</style>
